const styles = {
  layoutWrapper: {
    display: "flex",
    minHeight: "100vh",
    backgroundColor: "#F8F8FB",
  },
  main: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "space-between",
  },
};

export default styles;
